<template>
  <v-container class="fill-height eservice_type" fluid>
    <v-layout column class="eservice_inner_wrap">
      <h2 class="outside_title d-flex type2">
        {{ $t('user.agent.information.title') }}
        <v-spacer></v-spacer>
        <span class="loc_postion">
            <span class="front_loc">{{ $t('user.title') }} > </span>
            <span class="back_loc">{{ $t('user.agent.information.title') }}</span>
        </span>
      </h2>

      <v-layout column class="ma-0 pos-r center__wrapper">
        <v-flex class="inner_basic_wrap type2">
          <div class="component_7">
            <div class="copy_info bg-333 d-flex align-center pa-40 pt-20 pb-20">
              <v-col cols="6" class="pa-0">
                <p>{{ name_ar }}</p>
                <p>{{ name_en }}</p>
              </v-col>
              <v-col cols="6" class="text-right p_ty2 pa-0">
                <p>{{ $t('user.agent.information.fields.regeistry') }} # {{ company_regiration_no }}</p>
              </v-col>
            </div>
          </div>
          <v-row class="ma-0">
            <v-col class="pa-0">
              <v-row>
                <v-col class="pt-0">
                  <h2 class="m_title">{{ $t('user.agent.information.fields.english_address') }}</h2>
                </v-col>
              </v-row>
              <v-row class="pa-20 pt-0">
                <v-col cols="12">
                  <h2 class="nec_title">{{ $t('user.agent.information.fields.address') }}</h2>
                  <div class="input_text_type_basic wp100 mt-10">
                    <v-text-field
                      dense
                      outlined
                      disabled
                      hide-details
                      class="ft-size12 br_none"
                      v-model="address_en"
                    >
                    </v-text-field>
                  </div>
                </v-col>
                <v-col cols="12" md="6">
                  <h2 class="nec_title italic ftw_light">{{ $t('user.agent.information.fields.city') }}</h2>
                  <div class="input_text_type_basic wp100 mt-10">
                    <v-text-field
                      dense
                      outlined
                      disabled
                      hide-details
                      class="ft-size12 br_none"
                      v-model="city_name_en"
                    >
                    </v-text-field>
                  </div>
                </v-col>
                <v-col cols="12" md="6">
                  <h2 class="nec_title italic ftw_light">{{ $t('user.agent.information.fields.country') }}</h2>
                  <div class="input_text_type_basic wp100 mt-10">
                    <v-text-field
                      dense
                      outlined
                      disabled
                      hide-details
                      class="ft-size12 br_none"
                      v-model="residence_country_name_en"
                    >
                    </v-text-field>
                  </div>
                </v-col>
              </v-row>


              <v-row>
                <v-col calss="pt-0">
                  <h2 class="m_title">{{ $t('user.agent.information.fields.arabic_address') }}</h2>
                </v-col>
              </v-row>
              <v-row class="pa-20 pt-0">
                <v-col cols="12">
                  <h2 class="nec_title italic ftw_light">{{ $t('user.agent.information.fields.address') }}</h2>
                  <div class="input_text_type_basic wp100 mt-10 text-right">
                    <v-text-field
                      dense
                      outlined
                      disabled
                      hide-details
                      class="ft-size12 arabic_align br_none"
                      v-model="address_ar"
                    >
                    </v-text-field>
                  </div>
                </v-col>
                <v-col cols="12" md="6" class="pt-0">
                  <h2 class="nec_title italic ftw_light">{{ $t('user.agent.information.fields.city') }}</h2>
                  <div class="input_text_type_basic wp100 mt-10 text-right">
                    <v-text-field
                      dense
                      outlined
                      disabled
                      hide-details
                      class="ft-size12 arabic_align br_none"
                      v-model="city_name_ar"
                    >
                    </v-text-field>
                  </div>
                </v-col>
                <v-col cols="12" md="6" class="pt-0">
                  <h2 class="nec_title italic ftw_light">{{ $t('user.agent.information.fields.country') }}</h2>
                  <div class="input_text_type_basic wp100 mt-10 text-right">
                    <v-text-field
                      dense
                      outlined
                      disabled
                      hide-details
                      class="ft-size12 arabic_align br_none"
                      v-model="residence_country_name_ar"
                    >
                    </v-text-field>
                  </div>
                </v-col>
              </v-row>


              <v-row>
                <v-col class="pt-0">
                  <h2 class="m_title">{{ $t('user.agent.information.fields.pobox') }}</h2>
                  <div class="input_text_type_basic wp48 mt-15 pa-20 pt-0 pb-0">
                    <v-text-field
                      dense
                      outlined
                      disabled
                      hide-details
                      class="ft-size12 br_none"
                      v-model="pobox"
                    >
                    </v-text-field>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="pt-0">
                  <h2 class="m_title">{{ $t('user.agent.information.fields.postal') }}</h2>
                  <div class="input_text_type_basic wp48 mt-15 pa-20 pt-0 pb-0">
                    <v-text-field
                      dense
                      outlined
                      disabled
                      hide-details
                      class="ft-size12 br_none"
                      v-model="postal"
                      maxlength="16"
                    >
                    </v-text-field>
                  </div>
                </v-col>
              </v-row>

              <h2 class="m_title">{{ $t('user.agent.information.fields.contact_no') }}</h2>
              <v-row class="pa-20 pb-0">
                <v-col cols="12" md="4" class="pb-0">
                  <h2 class="nec_title">{{ $t('user.agent.information.fields.telephone') }}</h2>
                  <div class="input_text_type_basic mt-10">
                    <v-text-field
                      dense
                      outlined
                      disabled
                      hide-details
                      class="ft-size12 br_none"
                      v-model="telephone"
                    >
                    </v-text-field>
                  </div>
                </v-col>
                <v-col cols="12" md="4" class="pb-0">
                  <h2 class="nec_title">{{ $t('user.agent.information.fields.mobile') }}</h2>
                  <div class="input_text_type_basic mt-10">
                    <v-text-field
                      dense
                      outlined
                      disabled
                      hide-details
                      class="ft-size12 br_none"
                      v-model="mobile"
                    >
                    </v-text-field>
                  </div>
                </v-col>
                <v-col cols="12" md="4" class="pb-0">
                  <h2 class="nec_title">{{ $t('user.agent.information.fields.fax') }}</h2>
                  <div class="input_text_type_basic mt-10">
                    <v-text-field
                      dense
                      outlined
                      disabled
                      hide-details
                      class="ft-size12 br_none"
                      v-model="fax"
                    >
                    </v-text-field>
                  </div>
                </v-col>
              </v-row>


              <h2 class="m_title mt-25">{{ $t('user.agent.information.fields.proof_of_identity') }}</h2>
              <v-row class="pl-10 mt-25">
                <v-col>
                  <h2 class="nec_title">{{ $t('user.agent.information.fields.registry_certification') }}</h2>
                  <div class="input_text_type_basic wp100 mt-15 d-flex">
                    <a v-if="registry_cert_file_key" style="text-decoration:none; color:#222" class="ft-size12" :href="downLoadUrl + registry_cert_file_key">
                      <v-icon color="#a01c2a">{{ getExtIcon(registry_cert_file_ext) }}</v-icon>
                      {{ registry_cert_file_name }}
                    </a>
                  </div>
                </v-col>
              </v-row>

              <h2 class="m_title mt-25">{{ $t('user.agent.information.fields.signature') }}</h2>
              <v-row class="mt-25">
                <v-col cols="4" class="sig__re">
                  <v-img
                    style="border:1px solid #ddd;"
                    width="100%"
                    :src="signSrc"
                    v-if="signSrc">
                  </v-img>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row class="ma-0 btn_wrap pt-30 pb-30" v-if="user_group_type_code === '3804'">
            <v-btn class="sign_in_btn type2 colorwh" text @click="$router.push('/user/agent/profile?tab=tab-2')">{{ $t('common.button.edit') }}</v-btn>
          </v-row>
        </v-flex>
      </v-layout>
    </v-layout>
  </v-container>
</template>

<script>
import requestApi from '@/utils/requestApi'
import utils from '@/utils/utils'
import eventBus from '@/utils/eventBus'
import store from '@/store'

export default {
  components :{
  },
  data (){
    return {
      outsideTitle : 'Agent Information',
      locPosition : {
        frontloc : 'Profile',
        backloc : 'Agent Information'
      },

      seq : '',
      company_type_code : '',
      company_regiration_no : '',
      name_ar : '',
      name_en : '',
      address_ar : '',
      address_en : '',
      city_name_ar : '',
      city_name_en : '',
      residence_country_code : '',
      residence_country_name_ar : '',
      residence_country_name_en : '',
      pobox : '',
      postal : '',
      registry_cert_file_key : '',
      registry_cert_file_name : '',
      registry_cert_file_ext : '',
      company_status_type_code : '',
      telephone : '',
      mobile : '',
      fax : '',
      representative_email : '',

      signSrc : '',

      downLoadUrl : process.env.VUE_APP_BASE_URL + '/file/download/',
      user_group_type_code: ''
    }
  },
  mounted(){
    window.scrollTo(0, 0)
    this.fnInit()
  },
  methods: {
    fnInit() {
      this.user_group_type_code = store.state.token.user_group_type_code
      this.fnGetCompanyInformation()
      this.fnGetSignFileKey()
    },
    fnGetCompanyInformation(){
      requestApi({
        url: '/users/company/information',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.seq = res.data.seq
            this.company_type_code = res.data.company_type_code
            this.company_regiration_no = res.data.company_regiration_no
            this.name_ar = res.data.name_ar
            this.name_en = res.data.name_en
            this.address_ar = res.data.address_ar
            this.address_en = res.data.address_en
            this.city_name_ar = res.data.city_name_ar
            this.city_name_en = res.data.city_name_en
            this.residence_country_code = res.data.residence_country_code
            this.residence_country_name_ar = res.data.residence_country_name_ar
            this.residence_country_name_en = res.data.residence_country_name_en
            this.pobox = res.data.pobox
            this.postal = res.data.postal
            this.registry_cert_file_key = res.data.registry_cert_file_key
            this.registry_cert_file_name = res.data.registry_cert_file_name
            this.registry_cert_file_ext = res.data.registry_cert_file_ext
            this.company_status_type_code = res.data.company_status_type_code
            this.telephone = res.data.telephone
            this.mobile = res.data.mobile
            this.fax = res.data.fax
            this.representative_email = res.data.representative_email
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.getCompanyInformation()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnGetSignFileKey(){
      requestApi({
        url: '/users/profile',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            if(res.data.representative_sign_image){
              this.signSrc = res.data.representative_sign_image
            }
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetSignFileKey()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    getExtIcon(fileExt){
      let ext = fileExt.toLowerCase()
      if(ext == 'doc' || ext == 'docx'){
        return 'mdi-file-word'
      }else if(ext == 'xlsx' || ext == 'xls'){
        return 'mdi-file-excel'
      }else if(ext == 'ppt' || ext == 'pptx'){
        return 'mdi-file-ppt'
      }else if(ext == 'pdf'){
        return 'mdi-file-pdf'
      }else if(ext == 'png' || ext == 'bmp' || ext == 'rle' || ext == 'dib' ||ext == 'gif' || ext == 'tif' || ext == 'tiff' || ext == 'jpg' ){
        return 'mdi-file-image'
      }else{
        return 'mdi-paperclip'
      }
    }
  },
}
</script>